import React from 'react';
import ClassNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import './index.scss';

const BookingReviewConfirmation = ({ theme = 't-Default' }) => {
  const containerClasses = ClassNames('ConfirmationContainer', theme);

  return (
    <div className={containerClasses}>
      <p className="lead">
        <FormattedMessage
          defaultMessage="You have Declined this Booking"
          description="Message shown when a booking has been declined"
        />
      </p>
      <p>
        <FormattedMessage
          defaultMessage="Didn't mean to decline this request?"
          description="Question asking if the decline was accidental"
        />
        <br />
        <FormattedMessage
          defaultMessage="Send us an email to {email}"
          description="Instructions to contact support to undo a declined booking"
          values={{
            email: <a href="mailto:support@anyroad.com">support@anyroad.com</a>,
          }}
        />
      </p>
    </div>
  );
};

BookingReviewConfirmation.displayName = 'BookingReview-Confirmation-AnyGuide';

export default BookingReviewConfirmation;
